
import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import { customStyles } from "../../selectStyles";
import { debounce } from "lodash";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { useTranslation } from "react-i18next";


const CCVExperienceAchievementAdd = ({
    getUserCcv,
    handleCloseExperienceAchivement,
    showExperienceAchivement,
    ExperienceData,
    resumeId
}) => {
    console.log("experienceAchivementData", ExperienceData);
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();
    const { t } = useTranslation()
    const [achivement, setAchivement] = useState("");
    const [achivementDate, setAchivementDate] = useState("");
    const [display, setDisplay] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const language = localStorage.getItem("Lang");
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisplay(true);
        const body = {
            deviceType: "Web",
            sessionId: sessionId,
            userExpId: ExperienceData.rsmExpId,
            id: resumeId,
            achievement: achivement,
            achivementDate: moment(achivementDate).format("YYYY-MM-DD"),
        };
        const body1 = {
            deviceType: "Web",
            sessionId: sessionId,
            userExpId: ExperienceData.userExprncId,
            achievement: achivement,
            achivementDate: moment(achivementDate).format("YYYY-MM-DD"),
            langKey: language === "en" ? "" : language,
        };
        console.log("body====>", body);
        if (achivement === '' || achivementDate === '') {
            toast.error(t("modals.Please fill all the required fields"));
        } else {
            const apiUrl = ExperienceData.isSyncedWithUserData
                ? `/UserData/AddExperienceAcheivement`
                : `ResumeData/AddExperienceAcheivement`;

            const payload = ExperienceData.isSyncedWithUserData ? body1 : body;
            try {
                const res = await axios.post(apiUrl, payload);
                // toast.success(res.data.message);
                handleCloseExperienceAchivement();
                getUserCcv();
                setAchivement("");
                setAchivementDate('')
                setDisplay(false)
                setToastMessage(res.data.message);
                setShowToast(true);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    setWarningToastMessage(error.response.data.message);
                    setShowWarningToast(true);
                } else {
                    setErrorToastMessage(error.response.data.message);
                    setShowErrorToast(true);
                }
            }
        }
    };

    // useEffect(() => {
    //     if (showExperienceAchivement) {
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //         document.body.classList.add('modal-open'); // When a modal opens
    //     } else {
    //         document.body.style.overflow = 'unset';
    //         document.documentElement.style.overflow = '';
    //         document.body.classList.remove('modal-open'); // When a modal closes
    //     }
    // }, [showExperienceAchivement]);

      //************************profile headline Start  ************************//
//   const [achivement, setachivement] = useState(null);
  const [pageP, setPageP] = useState(0);
  const [typedprofile, setTypedprofile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [optionsP, setOptionsP] = useState([]);
  const [totalPagesProfile, setTotalPagesProfile] = useState(0);

  const logValue1 = debounce((typedprofile) => {
    setTypedprofile(typedprofile);
  }, 250);

   const addOptionsprofile = () => {
    setIsLoading(true);
     const data = {
        pageNumber: pageP + 1,
        pageSize: 100,
        deviceType: "Web",
     }
    axios
      .post(
        `Master/GetPositionHeadlineDDL?search=${typedprofile}&LangKey=${language}`, data
      )
      .then((response) => {
        console.log("response.........",response );
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item,index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>",mappedData)
          setOptionsP((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageP((prevPage) => prevPage + 1);
        setIsLoading(false);
        setTotalPagesProfile(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  }; 
  const handleOpenProfle = () => {
    setPageP(1);
  };

  const handleChangeProfile = (value) => {
    if (value=== null) { 
      setAchivement(null);
    } else {
      setAchivement(value.label);
    } 
  };

  const handleInputChangeProfile = (typedprofile) => {
    logValue1(typedprofile);
    if (!typedprofile) setPageP(0);
  };

  const handleMenuScrollToBottomProfile = () => {
    if (pageP < totalPagesProfile) {
      addOptionsprofile();
    }
  };

  useEffect(() => {
    if (typedprofile) {
    addOptionsprofile();
    }
  }, [typedprofile]);

  //************************ profile headline End  ************************//

const [showInputInsteadOfDropdown, setShowInputInsteadOfDropdown] = useState(false);


    return (
        <>
            {showExperienceAchivement && (
                <div
                    className="modal fade show modal-lg"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="setting-header d-flex justify-content-between align-items-center">
                                <h6>{t("modals.Add Experience Achievement")}</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-3 pointer"
                                    onClick={handleCloseExperienceAchivement}
                                />
                            </div>
                            <Form>
                                <div className="row modal-p settings CreateCompany">
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group controlId="grade">
                                                <Form.Label className="class-type">{t("modals.Achivement")} <span style={{ color: "red" }} className="ms-2">*</span></Form.Label>
                                                 
                                                 {/* <CreatableSelect
                                                    defaultValue={achivement}
                                                    options={optionsP}
                                                    styles={customStyles}
                                                    // optionRenderer={renderOption}
                                                    placeholder={"Search and Select Profile Headline"}
                                                    onOpen={handleOpenProfle}
                                                    onChange={handleChangeProfile}
                                                    onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                                                    onInputChange={handleInputChangeProfile}
                                                    isClearable
                                                            isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                                                    !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                                                }
                                                                onCreateOption={(inputValue) => {
                                                                    const newOption = { label: inputValue, value: inputValue };
                                                                    setOptionsP((prev) => [...prev, newOption]);
                                                                    setAchivement(inputValue); // directly set the value
                                                                }}
                                                                value={achivement ? { label: achivement, value: achivement } : null}
                                                     
                                                    invalid={display && achivement === ""}
                                                    /> */}
                                                {showInputInsteadOfDropdown ? (
                                                    <Form.Control
                                                        type="text"
                                                        className="Dark-Input-from-group"
                                                        value={achivement}
                                                        onChange={(e) => setAchivement(e.target.value)}
                                                        onBlur={() => setShowInputInsteadOfDropdown(false)}
                                                        autoFocus
                                                    />
                                                    ) : (
                                                    <CreatableSelect
                                                        defaultValue={achivement}
                                                        options={optionsP}
                                                        styles={customStyles}
                                                        placeholder={t("modals.Search and Select Responsibilities")}
                                                        onOpen={handleOpenProfle}
                                                        onChange={(selectedOption) => {
                                                        if (selectedOption) {
                                                            setAchivement(selectedOption.value);
                                                            setShowInputInsteadOfDropdown(true); // switch to input for editing
                                                        } else {
                                                            setAchivement("");
                                                        }
                                                        }}
                                                        onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                                                        onInputChange={handleInputChangeProfile}
                                                        isClearable
                                                        isValidNewOption={(inputValue, _, selectOptions) =>
                                                        !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                                        }
                                                        onCreateOption={(inputValue) => {
                                                        const newOption = { label: inputValue, value: inputValue };
                                                        setOptionsP((prev) => [...prev, newOption]);
                                                        setAchivement(inputValue);
                                                        setShowInputInsteadOfDropdown(true); // allow further edit
                                                        }}
                                                        value={achivement ? { label: achivement, value: achivement } : null}
                                                        className={display && achivement === "" ? "is-invalid" : ""}
                                                    />
                                                    )}                                               


                                                {display && !achivement ? (
                                                    <span className="error_msg_lbl">{t("modals.Search and Select Responsibilities")}</span>
                                                ) : null}
                                            </Form.Group>
                                        </Col>
                                        <Col md={12} className="mb-2">
                                            <Form.Group controlId="endYear">
                                                <Form.Label className="class-type">{t("modals.Achivement Date")} <span style={{ color: "red" }} className="ms-2">*</span></Form.Label>
                                                <Flatpickr 
                                                    type="number"
                                                    options={{maxDate: new Date() }}
                                                    maxdate='today'
                                                    value={achivementDate}
                                                    onChange={(date) => setAchivementDate(date[0])}
                                                    placeholder={t("modals.Enter Achivement Date")}

                                                />
                                                {display && !achivementDate ? (
                                                    <span className="error_msg_lbl">{t("modals.Select Achievement Date")} </span>
                                                ) : null}
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <div className="text-end mt-4">
                                        <button
                                            type="button"
                                            className="closebtn me-2 ms-2"
                                            onClick={handleCloseExperienceAchivement}
                                            style={{ width: "70px" }}
                                        >
                                          {t("User Profile.Close")}
                                        </button>
                                        <button
                                            type="button"
                                            className="mainBtn1"
                                            onClick={handleSubmit}
                                            style={{ width: "107px" }}
                                        >
                                        {t("User Profile.Submit")}
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            )}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>



    );
};

export default CCVExperienceAchievementAdd;
